import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer } from 'preact-i18n';
import Markdown from 'preact-markdown';
import { route } from 'preact-router';

import localUtil from '../../lib/util';

import FrontpageLoggedIn from './loggedIn';
import FrontpageNotLoggedIn from './notLoggedIn';

@observer
class Frontpage extends Component {
  	constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        const { appState } = this.props.stores;
        appState.checkVersion();
    }

    render() {
        const { appState, userStore } = this.props.stores;
        const { isDoneLoadingUser, user = {}, isAdmin, isTester, isVeterinary } = userStore;
        if (!isDoneLoadingUser) {
            return <>
                <div class='d-flex h-100 justify-content-center align-items-center'>
                    {/* Large spinner */}
                    <div class='spinner-border ' role='status'>
                        <span class='sr-only'>Loading...</span>
                    </div>
                </div>
            </>;
        }

        if (user.id) {
            return (<FrontpageLoggedIn stores={this.props.stores} {...this.props} />);
        }
        return (<FrontpageNotLoggedIn stores={this.props.stores} {...this.props} />);
    }
}

export default Frontpage;
